import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './icon.component.scss';
var Icon = /** @class */ (function (_super) {
    tslib_1.__extends(Icon, _super);
    function Icon(element) {
        return _super.call(this, element) || this;
    }
    Icon.prototype.init = function () {
        this.parser = new DOMParser();
        this.serializer = new XMLSerializer();
        this.gradient = this.element.getAttribute('data-gradient');
        this.setPath();
        this.setIcon(this.element.getAttribute('data-icon'));
    };
    Icon.prototype.embedSVG = function (svgElement) {
        this.element.innerHTML = svgElement;
    };
    Icon.prototype.bindEvents = function () { };
    Icon.prototype.setPath = function () {
        var path = this.element.getAttribute('data-path');
        if (path && path != "") {
            if (path === '/assets/icons' || path === '/assets/icons/') {
                this.assetPath = "/file_source/assets/icons/";
            }
            else {
                this.assetPath = path + (path[path.length - 1] != '/' ? '/' : '');
            }
        }
        else {
            this.assetPath = "/file_source/assets/icons/";
        }
    };
    Icon.prototype.setIcon = function (icon) {
        var _this = this;
        this.http.get("" + this.assetPath + icon + ".svg")
            .then(function (response) {
            _this.svg = _this.setGradient(response.data);
            _this.embedSVG(_this.svg);
        });
    };
    Icon.prototype.setGradient = function (data) {
        var svg = this.parser.parseFromString(data, "text/xml");
        if (this.gradient === 'gradient' && svg.getElementsByTagName("linearGradient")[0]) {
            var svgId_1 = this.generateGuid();
            svg.getElementsByTagName("linearGradient")[0].setAttribute("id", "gradient-" + svgId_1);
            svg.getElementsByTagName("path")[0].setAttribute("fill", "url(#gradient-" + svgId_1 + ")");
            svg.getElementsByTagName("linearGradient")[0].getElementsByTagName("stop")[0].setAttribute("stop-color", "#0062E1");
            svg.getElementsByTagName("linearGradient")[0].getElementsByTagName("stop")[1].setAttribute("stop-color", "#0062E1");
            var paths = Array.from(svg.querySelectorAll('path'));
            paths.forEach(function (path) {
                path.setAttribute("fill", "url(#gradient-" + svgId_1 + ")");
            });
        }
        else if (this.gradient === 'gradient-sponsorship' && svg.getElementsByTagName("linearGradient")[0]) {
            var svgId_2 = this.generateGuid();
            svg.getElementsByTagName("linearGradient")[0].setAttribute("id", "gradient-" + svgId_2);
            svg.getElementsByTagName("path")[0].setAttribute("fill", "url(#gradient-" + svgId_2 + ")");
            svg.getElementsByTagName("linearGradient")[0].getElementsByTagName("stop")[0].setAttribute("stop-color", "#d52552");
            svg.getElementsByTagName("linearGradient")[0].getElementsByTagName("stop")[1].setAttribute("stop-color", "#ae3352");
            var paths = Array.from(svg.querySelectorAll('path'));
            paths.forEach(function (path) {
                path.setAttribute("fill", "url(#gradient-" + svgId_2 + ")");
            });
        }
        else if (this.gradient === 'gradient-indigo' && svg.getElementsByTagName("linearGradient")[0]) {
            var svgId_3 = this.generateGuid();
            svg.getElementsByTagName("linearGradient")[0].setAttribute("id", "gradient-" + svgId_3);
            svg.getElementsByTagName("path")[0].setAttribute("fill", "url(#gradient-" + svgId_3 + ")");
            svg.getElementsByTagName("linearGradient")[0].getElementsByTagName("stop")[0].setAttribute("stop-color", "#0a2240");
            svg.getElementsByTagName("linearGradient")[0].getElementsByTagName("stop")[1].setAttribute("stop-color", "#0089ff");
            var paths = Array.from(svg.querySelectorAll('path'));
            paths.forEach(function (path) {
                path.setAttribute("fill", "url(#gradient-" + svgId_3 + ")");
            });
        }
        return this.serializer.serializeToString(svg);
    };
    Icon.prototype.generateGuid = function () {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    };
    return Icon;
}(Base));
export { Icon };



//////////////////
// WEBPACK FOOTER
// ./components/icon/icon.component.ts
// module id = 364
// module chunks = 0